// SCO-2200: native owns appearance only in the NEW-chrome apps — keyed on the
// SCO-1870 headerHeight contract (URL param at boot, --sh-chrome-top after
// in-page navigation drops params) or the header-menu's in-sheet settings
// routes. The legacy apps pass platform= too but have no native Appearance
// menu, so platform= alone must NOT hide the web toggle or drop the override.
export const nativeOwnsAppearance = () => {
  if (typeof window === "undefined") return false;
  const headerHeight = parseFloat(
    new URLSearchParams(window.location.search).get("headerHeight"),
  );
  if (headerHeight > 0) return true;
  if (document.documentElement.style.getPropertyValue("--sh-chrome-top"))
    return true;
  return /\/(player|organizer)\/settings\/?$/.test(window.location.pathname);
};
